module.exports = __webpack_public_path__ + "img/happy.42f73b6c.svg";